import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    FieldError
} from '../../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    TextField,
    CheckboxWithLabel,
    Select
} from 'formik-material-ui';

import {
    Grid,
    IconButton,
    InputLabel,
    FormControl,
    MenuItem,
    Typography
} from '@material-ui/core';

import { PageContext } from '../../PageContext';

import { useTranslation } from "react-i18next";

import { BaseMenuItem } from './BaseMenuItem';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    formControl: {
        width: '100%'
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: "-6px"
    }
}));

const isAbsoluteUrlOptions = [
    { label: 'URL', value: true },
    { label: 'Wordpress page', value: false }
]

export const WebViewMenuItem = ({
    item,
    icons,
    formRef,
    errors,
    validationSchema,
    disabled,
    upload,
    onUpdated,
    onRemove,
    onSubmit,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        pages
    } = state;


    return <BaseMenuItem
        item={item}
        icons={icons}
        formRef={formRef}
        errors={errors}
        validationSchema={validationSchema}
        disabled={disabled}
        upload={upload}
        onUpdated={onUpdated}
        onRemove={onRemove}
        onSubmit={onSubmit}
    >
        <Grid item xs={12}>
            <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel>{t("LabelLinkType")}</InputLabel>
                <Field
                    className={classes.field}
                    name="props.isAbsoluteUrl"
                    label={t("LabelLinkType")}
                    component={Select}
                    disabled={disabled}>
                    {isAbsoluteUrlOptions.map(option =>
                        <MenuItem
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </MenuItem>)}
                </Field>
            </FormControl>
            <FieldError
                name={`[${item.id}].props.isAbsoluteUrl`}
                errors={errors}
            />
        </Grid>
        {item.props.isAbsoluteUrl ?
            <Grid item xs={12}>
                <Field
                    className={classes.field}
                    name="props.url"
                    type="text"
                    variant="outlined"
                    label={t("LabelUrl")}
                    component={TextField}
                    disabled={disabled}
                />
                <FieldError
                    name={`[${item.id}].props.url`}
                    errors={errors}
                />
            </Grid>
            :
            <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel>{t("LabelSelectPage")}</InputLabel>
                    <Field
                        className={classes.field}
                        name="props.wpUrl"
                        label={t("LabelSelectPage")}
                        component={Select}
                        disabled={disabled}>
                        {pages.map(page =>
                            <MenuItem
                                key={page.link}
                                value={page.link}
                            >
                                {page.slug}
                            </MenuItem>)}
                    </Field>
                </FormControl>
                <FieldError
                    name={`[${item.id}].props.wpUrl`}
                    errors={errors}
                />
            </Grid>
        }
        <Grid item xs={12}>
            <Field
                type="checkbox"
                name="props.allowShare"
                component={CheckboxWithLabel}
                Label={{ label: t("LabelAllowShareWebView") }}
                disabled={disabled}
            />
            <FieldError
                name={`[${item.id}].allowShare`}
                errors={errors}
            />
        </Grid>
    </BaseMenuItem>
}